import { DatePickerValue, DatesRangeValue, MultiSelectProps } from 'ui';

/**
 * Transforms a string into a date range value, optionally if the value is already a date range value return it
 */
const transformStringIntoDateValue = (dateString?: string | DatePickerValue<'range'>) => {
  if (!dateString) return undefined;
  if (typeof dateString !== 'string') return dateString;
  // turn a string into a date
  const dateArray = dateString.split('|');
  const startDate = new Date(dateArray[0]);
  const endDate = new Date(dateArray[1]);
  return [startDate, endDate] as DatesRangeValue;
};

const deserializeMultiSelect = (value?: string | MultiSelectProps['value']) => {
  if (typeof value === 'string') {
    return value?.split?.(', ');
  }
  return value;
};

export { deserializeMultiSelect, transformStringIntoDateValue };
